import { render, staticRenderFns } from "./ManterTipoCreditoAssuntoExibir.vue?vue&type=template&id=9a9cf13e&scoped=true&"
import script from "./ManterTipoCreditoAssuntoExibir.vue?vue&type=script&lang=js&"
export * from "./ManterTipoCreditoAssuntoExibir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a9cf13e",
  null
  
)

export default component.exports